interface Props {
  className?: string;
  description: string;
}

export default function TableDataColumn3(props: Props) {
  const { className, description } = props;

  const getClassNames = () => {
    const defaultClasses = "text-left pl-2";

    if (className) {
      return `${defaultClasses} ${className}`;
    }

    return defaultClasses;
  };

  return(
    <td className={getClassNames()}>
      {description}
    </td>
  );
}